import { InputStateInterface } from 'common/module/input/state.interface';
import { InputValidatorInterface } from 'common/module/input/validator.interface';

export class InputValidatorMaxLength implements InputValidatorInterface {
  /**
   * Constructor
   */
  constructor(protected message: string, protected maxLength: number, protected inclusive: boolean = false) {}

  /**
   * @inheritDoc
   */
  public getError(value: string, context: { [key: string]: InputStateInterface }): string {
    const errorMessage = this.message.replace('{max-length}', String(this.maxLength));

    if (this.inclusive) {
      return value.length >= this.maxLength ? errorMessage : '';
    } else {
      return value.length > this.maxLength ? errorMessage : '';
    }
  }
}
